import { useCallback } from 'react';
import { Step, Workflow } from './Workflow';
import { FeatureGroups } from 'state/tenant';
import useFeature from 'hooks/useFeature';

const usePrequalOfferPush = () => {
  const { isGroupEnabled } = useFeature();
  const getWorkflow = useCallback((): Workflow => {
    return {
      stepsEnabled: {
        [Step.PREQUAL_OFFER_PUSH_START]: true,
        [Step.APPLICATION]: true,
        [Step.ADD_ONS]: isGroupEnabled(FeatureGroups['add-ons']),
        [Step.REVIEW_TERMS]: true,
      },
      paths: {
        [Step.PREQUAL_OFFER_PUSH_START]: '/prequal/offer-push',
        [Step.APPLICATION]: '/prequal/offer-push-application',
        [Step.ADD_ONS]: '/add-ons',
        [Step.REVIEW_TERMS]: '/prequal/review-terms',
      },
      progressStartStep: Step.APPLICATION,
      restartStep: Step.PREQUAL_OFFER_PUSH_START,
      timeoutRestartPath: '/prequal/offer-push',
    };
  }, [isGroupEnabled]);

  return getWorkflow;
};

export default usePrequalOfferPush;
